import Vue from "vue";
import features from "../features.json";

const CURRENT_TARGET = process.features.target;

const feature = new Vue({
  computed: {
    currentTarget() {
      return CURRENT_TARGET;
    },
    isAudiTarget() {
      return CURRENT_TARGET.indexOf("audi") > -1;
    },
  },
  methods: {
    isEnabled(name) {
      if (!features[name] || !features[name].target) {
        console.error("Unknown feature: " + name);
        return false;
      }

      let targets = features[name].target.split(" ");
      if (targets.indexOf(CURRENT_TARGET) > -1) return true;
      return false;
    },
    isDisabled(name) {
      return !this.isEnabled(name);
    },
  },
});

export default feature;



// WEBPACK FOOTER //
// ./src/feature.js